
/**
 * Stocke les infos client dans le store au chargement de la page si le token est présent
 */

// "to" n'existe pas dans le store auth, le middleware ne sert donc a rien, à voir quel était le but inital pour corriger
import { useAuthStore } from "@/store/auth";

export default defineNuxtRouteMiddleware(() => {

  const { $pinia } = useNuxtApp();
  const authStore = useAuthStore($pinia);

  if (!authStore.to === "/commander") {
    return navigateTo("/commander/creation-compte", { replace: true });
  }

  return;
})
